import { supabase } from "@/integrations/supabase/client";
import type { Tables, TablesInsert } from "@/integrations/supabase/types";

export async function fetchUserLikedMedia(userId: string): Promise<Tables<"liked_media">[]> {
  const { data, error } = await supabase
    .from("liked_media")
    .select("*")
    .eq("user_id", userId)
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data ?? [];
}

export async function insertLikedMedia(
  row: TablesInsert<"liked_media">
): Promise<Tables<"liked_media">> {
  const { data, error } = await supabase
    .from("liked_media")
    .insert(row)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteLikedMedia(userId: string, mediaUrl: string): Promise<void> {
  const { error } = await supabase
    .from("liked_media")
    .delete()
    .eq("user_id", userId)
    .eq("media_url", mediaUrl);

  if (error) throw error;
}

export async function deleteLikedMediaByUrl(mediaUrl: string): Promise<void> {
  // Best-effort deletion — does not throw on error
  await supabase
    .from("liked_media")
    .delete()
    .eq("media_url", mediaUrl);
}
